import * as types from "./actionTypes"

const initialState = {
    userProfile: [],
    accesRights: [],
    selectedShipper: {},
    ebolWOAccess: false, // Ebol wabtec one access
    enhancedVisibilityRedirect: false,
    enhancedVisibilityMenu: false,
}

export default function userProfileReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_ORGANIZATIONS_DATA_SUCCESS:
            return {
                ...state,
                userProfile: action.payload,
            }

        case types.FETCH_ACCESS_RIGHTS_SUCCESS:
            return {
                ...state,
                accesRights: action.userPermissionData,
                userProfile: action.userProfileData,
            }

        case types.SELECT_SHIPPER:
            return {
                ...state,
                selectedShipper: action.payload,
            }
        case types.CHECK_EBOL_WO_ACCESS_SUCCESS:
            return {
                ...state,
                ebolWOAccess: true,
            }
        case types.CHECK_EBOL_WO_ACCESS_FAILURE:
            return {
                ...state,
                ebolWOAccess: false,
            }
        case types.SET_ENHANCED_VISIBILITY_REDIRECT:
            return {
                ...state,
                enhancedVisibilityRedirect: action.payload,
            }
        case types.SHOW_ENHANCED_VISIBILITY_MENU:
            return {
                ...state,
                enhancedVisibilityMenu: true,
            }
        case types.HIDE_ENHANCED_VISIBILITY_MENU:
            return {
                ...state,
                enhancedVisibilityMenu: false,
            }
        default:
            return state
    }
}
